import React, { Fragment } from "react";
import PropTypes from "prop-types";
import styles from "./index.module.scss";

const BreadCrumbs = ({ breadcrumbs }) => (
	<nav aria-label="breadcrumb" className={styles.breadcrumbs}>
		<ul className={styles.breadcrumbsList}>
			{breadcrumbs.map((breadcrumb, index) => (
				<Fragment key={breadcrumb.href}>
					<li
						key={breadcrumb.href}
						className={index === breadcrumbs.length - 1 ? styles.active : ""}
					>
						<a href={breadcrumb.href}>{breadcrumb.text}</a>
					</li>
					{index !== breadcrumbs.length - 1 && (
						<svg
							role="img"
							aria-label="breadcrumb separator"
							className={styles.seperator}
							width="12"
							height="12"
							viewBox="0 0 12 12"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<line
								x1="11.6036"
								y1="0.728553"
								x2="0.996952"
								y2="11.3352"
								stroke="#5B5B5B"
							/>
						</svg>
					)}
				</Fragment>
			))}
		</ul>
	</nav>
);

BreadCrumbs.prototype = {
	breadcrumbs: PropTypes.arrayOf({
		href: PropTypes.string,
		text: PropTypes.string,
	}),
};

export default BreadCrumbs;
